import React from 'react';
import './App.css';
import Charts from './components/charts';
import Auth from './components/Login';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';

const AppContent = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="App" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {user ? (
        <>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '10px',
            boxSizing: 'border-box'
          }}>
            <button
              onClick={signOut}
              style={{
                padding: '8px 16px',
                fontSize: '16px',
                borderRadius: '4px'
              }}
            >
              Sign Out
            </button>
          </div>
          <h1>Sensor Data Chart</h1>
          <Charts />
        </>
      ) : (
        <Auth onAuthSuccess={() => { }} />
      )}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
